import { ActionType } from '@/actions';
import { ActionSetPlayNumber } from './interfaces';

export const setPlayNumber = (
  game: number,
  values: number[]
): ActionSetPlayNumber => {
  return {
    type: ActionType.PLAY_NUMBER_SET,
    game,
    values,
  };
};
